"use client";

import { useEffect, useState } from "react";

export const useBibleHTML = (html: string): [string, string, string] => {
  // server rendering of raw HTML differs from client rendering, so we need to make this state
  const [body, setBody] = useState<string>(undefined);
  const [copyright, setCopyright] = useState<string>(undefined);
  const [title, setTitle] = useState<string>(undefined);

  /* HTML is structured in one of these two ways:
   * REGULAR CHAPTER
   * Wrapper
   *   topContentLink
   *   body (text itself)
   *   bottomContentLink
   *   copyright
   *
   * INTRO "CHAPTER"
   * Wrapper
   *   button header
   *   body + copyright
   *
   * Intros (mostly NAB for now) do not have a topContentLink or bottomContentLink.
   * We need to remove the content link chunks (we add those components ourselves)
   * but retain everything else. Intros therefore have only one chunk when split
   * by content links, and everything else has (effectively) two chunks, the body
   * and the copyright.
   */

  useEffect(() => {
    if (!html) {
      setBody(undefined);
      setCopyright(undefined);
      setTitle(undefined);
    } else {
      const htmlPieces1 = html?.split(
        /<div (?:class|id)="topContentLink"><\/div>/,
      );
      if (htmlPieces1.length === 1) {
        const titleRegex =
          /<div class="chapter-nav"><button class="chapter-nav-header">([\w\s]+)<\/button><\/div>/;
        // intro, no links
        const reResult = titleRegex.exec(html);
        if (!reResult) {
          setBody(html);
          setCopyright(undefined);
          setTitle(undefined);
        } else {
          const [, foundTitle] = reResult;
          setBody(html.replace(titleRegex, ""));
          setCopyright(undefined);
          setTitle(foundTitle);
        }
      } else {
        const htmlPieces2 = htmlPieces1[1]?.split(
          /<div (?:class|id)="bottomContentLink"><\/div>/,
        );
        setBody(htmlPieces2?.[0]);
        setCopyright(htmlPieces2?.[1]);
        setTitle(undefined);
      }
    }
  }, [html]);

  return [body, copyright, title];
};
